import { convertFromHTML } from 'draft-convert';
import { EditorState, Modifier } from 'draft-js';

const OFFICE_TAGS_TO_REMOVE = /^(STYLE|META|LINK|TITLE|XML|O:P|W:WORDDOCUMENT)$/i;
const BOLD_STYLE = /\bfont-weight:\s*(bold|[7-9]00|bolder)\b/i;
const ITALIC_STYLE = /\bfont-style:\s*(italic|oblique)\b/i;
const UNDERLINE_STYLE = /\btext-decoration:[^;"]*underline/i;
const STRIKETHROUGH_STYLE = /\btext-decoration:[^;"]*line-through/i;

const promoteFormatting = (element) => {
	const style = element.getAttribute('style') || '';
	let tagName = null;

	if (BOLD_STYLE.test(style) && !['STRONG', 'B'].includes(element.tagName)) {
		tagName = 'strong';
	} else if (ITALIC_STYLE.test(style) && !['EM', 'I'].includes(element.tagName)) {
		tagName = 'em';
	} else if (UNDERLINE_STYLE.test(style) && element.tagName !== 'U') {
		tagName = 'u';
	} else if (STRIKETHROUGH_STYLE.test(style) && !['S', 'STRIKE', 'DEL'].includes(element.tagName)) {
		tagName = 's';
	}

	if (!tagName) {
		element.removeAttribute('style');
		element.removeAttribute('class');
		return element;
	}

	const wrapper = element.ownerDocument.createElement(tagName);
	while (element.firstChild) {
		wrapper.appendChild(element.firstChild);
	}
	element.replaceWith(wrapper);
	wrapper.removeAttribute('style');
	wrapper.removeAttribute('class');
	return wrapper;
};

export const sanitizeOfficeHtml = (html) => {
	const doc = new DOMParser().parseFromString(html, 'text/html');

	doc.querySelectorAll('*').forEach((element) => {
		if (OFFICE_TAGS_TO_REMOVE.test(element.tagName)) {
			element.remove();
		}
	});

	const elements = Array.from(doc.body.querySelectorAll('*')).reverse();
	elements.forEach((element) => {
		if (element.tagName === 'SPAN' || element.tagName === 'P' || element.tagName === 'DIV' || element.tagName === 'FONT') {
			promoteFormatting(element);
			return;
		}

		element.removeAttribute('style');
		element.removeAttribute('class');
	});

	return doc.body.innerHTML;
};

export const handleOfficePaste = (text, html, editorState, onChange) => {
	if (!html) {
		return false;
	}

	try {
		const cleanedHtml = sanitizeOfficeHtml(html);
		const pastedContent = convertFromHTML(cleanedHtml);

		if (!pastedContent.hasText()) {
			return false;
		}

		const selection = editorState.getSelection();
		const newContent = Modifier.replaceWithFragment(
			editorState.getCurrentContent(),
			selection,
			pastedContent.getBlockMap()
		);

		const newEditorState = EditorState.push(editorState, newContent, 'insert-fragment');
		onChange(EditorState.forceSelection(newEditorState, newContent.getSelectionAfter()));
		return true;
	} catch (error) {
		if (process?.env?.NODE_ENV === 'development') {
			console.error('Office paste handling failed:', error);
		}
		return false;
	}
};
